import { useParams } from 'react-router';

export default function useContent() {
	const { id } = useParams<{ id: string }>();

	return {
		id,
	};
}
